const visitorFieldNames = [
    'sop_referrerurl',
    'sop_landingpage',
    'sop_utmsource',
    'sop_utmcampaign',
    'sop_utmmedium',
    'sop_utmcontent',
    'sop_leadchannel',
];
export default visitorFieldNames;
